"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookieKey = void 0;
exports.getCookies = getCookies;
const tslib_1 = require("tslib");
const js_cookie_1 = tslib_1.__importDefault(require("js-cookie"));
var CookieKey;
(function (CookieKey) {
    CookieKey["USER_ID"] = "user_id";
    CookieKey["DEVICE_ID"] = "deviceId";
    CookieKey["GG_ID"] = "ggId";
    CookieKey["STORE_CODE"] = "x-grover-store";
    CookieKey["LOCALE"] = "locale";
})(CookieKey || (exports.CookieKey = CookieKey = {}));
function getCookies() {
    return {
        userId: js_cookie_1.default.get(CookieKey.USER_ID),
        deviceId: js_cookie_1.default.get(CookieKey.DEVICE_ID),
        ggId: js_cookie_1.default.get(CookieKey.GG_ID),
        storeCode: js_cookie_1.default.get(CookieKey.STORE_CODE),
        locale: js_cookie_1.default.get(CookieKey.LOCALE),
    };
}
//# sourceMappingURL=cookie.js.map